import dynamic from "next/dynamic";
const ProductsHorizontalTimerTabsComponent = dynamic(()=>import("./products-horizontal-timer-tabs-component"));
import ProductsHorizontalTimerTabsConfig from "./products-horizontal-timer-tabs-config";
import ProductsHorizontalTimerTabsAdvancedConfig from "./products-horizontal-timer-tabs-advanced-config";
export default {
    ProductsHorizontalTimerTabsComponent,
    ProductsHorizontalTimerTabsConfig,
    ProductsHorizontalTimerTabsAdvancedConfig
};
